import "../../assets/stylesheets/application.scss"
import "@hotwired/turbo-rails"
import {setupFlash} from './../shared/flash.js'
import {runCookieConsent} from './../shared/cookie_consent.js'
Turbo.session.drive = false

document.addEventListener('DOMContentLoaded', () => {
  setupFlash()
  runCookieConsent();
});